import { css } from 'linaria';

export const instoreSection = css`
  @media (--only-mobile) {
    position: relative;

    &::before {
      position: absolute;
      top: -40px;
      left: -16px;
      width: 100vw;
      height: 40px;
      background: linear-gradient(180deg, rgb(70 76 92 / 4%) 0%, rgb(255 255 255 / 0%) 100%);
      content: '';
    }
  }
`;

export const instoreTitle = css`
  && {
    width: max-content;
    color: var(--text-primary);

    &:hover {
      color: var(--success-primary);
    }
  }
`;

export const instoreSwiper = css`
  @media (--only-mobile) {
    .swiper-wrapper {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const instoreSlide = css`
  width: 180px;
  height: 180px;
  margin-right: 20px;
  overflow: hidden;
  border-radius: var(--rounding-l);
  box-shadow: inset 0 0 1px rgb(0 0 0 / 60%);

  &:last-of-type {
    margin-right: 0;

    @media (--only-mobile) {
      margin-bottom: 0;
    }
  }

  @media (--to-desktop) {
    width: 172px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 92px;
    margin-right: 0;
    margin-bottom: 16px;
  }
`;

export const instoreItem = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  &:hover {
    box-shadow: inset 0 0 1px #000;
  }

  @media (--only-mobile) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const instoreItemImage = css`
  align-self: flex-end;
  width: 112px;
  height: 80px;
  object-fit: contain;
  mix-blend-mode: multiply;

  @media (--only-mobile) {
    align-self: flex-start;
    order: 2;
    width: 88px;
    height: 64px;
  }
`;

export const instoreItemContent = css`
  padding: 20px;

  @media (--only-mobile) {
    padding: 16px;
  }
`;

export const instoreItemName = css`
  && {
    margin-bottom: 4px;

    @media (--only-mobile) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const instoreItemDescription = css`
  @media (--only-mobile) {
    width: 130px;
  }
`;
